import { useIntl } from 'react-intl';
import { RouteComponentProps } from 'react-router';
import { Toolbar } from '@rossum/ui/material';
import { DataGridPro } from '@rossum/ui/x-data-grid-pro';
import { DatasetDetailLayout } from '../dataset-detail/DatasetDetailLayout';
import { useOperations } from '../hooks/useOperations';
import { useTable } from '../hooks/useTable';
import { Dataset } from '../types';
import { getTransformedOperationsData } from './helpers';
import { tableSxStyles } from './styles';
import { useColumns } from './useColumns';

const DEFAULT_PAGE_SIZE = 20;

export const OperationStatusTable = ({ table }: { table: Dataset }) => {
  const intl = useIntl();
  const datasetOperations = useOperations({ datasetName: table.name });

  const paginationModel = { pageSize: DEFAULT_PAGE_SIZE, page: 0 };
  const pageSizeOptions = [10, DEFAULT_PAGE_SIZE, 50, 100];

  const rows = datasetOperations.data?.map(log =>
    getTransformedOperationsData(log)
  );

  const statuses =
    datasetOperations.data?.flatMap(operation =>
      operation.status ? [operation.status] : []
    ) ?? [];

  const columns = useColumns({ statuses });

  return (
    <DatasetDetailLayout table={table} tab="logs">
      <DataGridPro
        loading={datasetOperations.isLoading}
        columns={columns}
        rows={rows ?? []}
        disableColumnResize
        disableColumnMenu
        disableRowSelectionOnClick
        disableColumnReorder
        hideFooterRowCount
        pageSizeOptions={pageSizeOptions}
        pagination
        initialState={{ pagination: { paginationModel } }}
        getRowClassName={params =>
          params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
        }
        localeText={{
          noRowsLabel: intl.formatMessage({
            id: 'features.datasets.logs.empty',
          }),
        }}
        slots={{
          toolbar: Toolbar,
        }}
        slotProps={{
          loadingOverlay: {
            variant: 'linear-progress',
          },
          basePagination: {
            // @ts-expect-error wrong type
            sx: {
              // hide pagination when there are no rows
              display: rows?.length === 0 ? 'none' : 'inherit',
              [`> * p`]: {
                margin: 0,
              },
            },
          },
        }}
        sx={tableSxStyles}
      />
    </DatasetDetailLayout>
  );
};

export const OperationStatusTableWrapper = ({
  match: {
    params: { id },
  },
}: RouteComponentProps<{ id: string }>) => {
  const { data: table } = useTable(id);
  return table ? <OperationStatusTable table={table} /> : null;
};
